/**
 * @fileoverview System-web binding for the shared active-fire hook factory.
 * @module system-web/hooks/useActiveFirePerimeters
 *
 * Responsibilities:
 * - Inject the configured system-web active-fire service into the reusable hook facade.
 * Dependencies:
 * - System-web service adapter and @firesquirrel/fire-hazard-map-layers.
 * Architecture:
 * - Module-scoped dependency closure; no mutable global provider or cross-host state.
 * Notes:
 * - Refresh scheduling and source updates remain component-owned imperative concerns.
 */

import { createUseActiveFirePerimeters } from '@firesquirrel/fire-hazard-map-layers';
import { fetchActiveFirePerimeters } from '../services/activeFirePerimeterService';

/**
 * @hook useActiveFirePerimeters
 * Purpose: Expose the configured system-web active-fire fetch to map components.
 * Returns: fetchActiveFires for nationwide GeoJSON reads.
 * Side Effects: Each fetchActiveFires invocation performs one service read with telemetry.
 * Offline Behavior: Failures propagate so the caller can retain existing map data.
 */
export const useActiveFirePerimeters = createUseActiveFirePerimeters({
  fetchActiveFirePerimeters,
});
